export default {
  root: {
    flex: 1,
    alignItems: 'flex-end',
  },
};
